import { render, staticRenderFns } from "./ObjectDetailView.vue?vue&type=template&id=498d6abb&scoped=true"
import script from "./ObjectDetailView.vue?vue&type=script&lang=js"
export * from "./ObjectDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498d6abb",
  null
  
)

export default component.exports